import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  AportacionDIEstadoControllerService,
  OperacionGestionControllerService,
  AportacionDIEstadoDTO,
  CodigoOperacionFilterDTO,
  AportacionDiAdheridoControllerService,
  SolicitudGestoresDTO,
  SolicitudAdheridoPrevisionDTO,
  AdheridoControllerService,
  BusquedaAdheridoDTO,
  AportacionDIAdheridoPayloadDTO,
  AportacionDIAdheridoDTO,
  ParametrosControllerService
} from 'api-rest';
import { Observable, Subscription, tap } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DocumentService } from '../../../services/document.service';
import {ValidateService} from "../../../services/validate.service";
import moment from 'moment';
import { ContributionsDisImageDialogComponent } from '../contributions-dis-image-dialog/contributions-dis-image-dialog.component';
import swal from 'sweetalert2';
import { ContributionsDisDeclineDialogComponent } from '../contributions-dis-cancel-dialog/contributions-dis-cancel-dialog.component';
import { ContributionsDisPreviewDialogComponent } from '../contributions-dis-preview-dialog/contributions-dis-preview-dialog.component';

@Component({
  selector: 'app-holders-contributions-dis-dialog',
  templateUrl: './contributions-dis-dialog.component.html',
  styleUrls: ['./contributions-dis-dialog.component.scss'],
})
export class ContributionsDisDialogComponent implements OnInit {
  estadoArray: AportacionDIEstadoDTO[] = [];
  codigoLerArray: any[] = [];
  documentoArray: any[] = [];
  residuoArray: any[] = [];
  descripcionEnvaseArray: any[] = [];
  gestionArray: any[] = [];
  adheridoArray: any[] = [];
  nimaGestorArray: any[] = [];
  entityRoles: any[] = [];

  modelForm!: FormGroup;
  subscriptions: Subscription[] = [];
  roleEntities: any[] = [];
  documento: File | undefined;
  titulo: any;
  edicion = false;
  alta = false;
  estado: Number = 1;
  cargaCombos:boolean = true;

  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;
  cantidadMaxima: number = 0;
  cantidadMinima: number = 0;
  uipathForm!: FormGroup;

  operacionGestionEndpoint: string = this.environment.urlBackPoseedores + `api/v1/poseedores/operacion-gestion/codigo-operacion`;
  updateList: boolean = false;
  defaultOperacionesGestionParameters: any = {codigoLer: [null], poseedores: true};

  get styleEstadoAportaciones(): { [key: string]: string } {
    const estadoId = this.aportacion?.estado?.id;
    switch (estadoId) {
      case 1: return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 2: return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 3: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 4: return { 'background-color': '#773E90', 'color': '#ffffff' };
      case 5: return { 'background-color': '#A7A6A6', 'color': '#ffffff' };
      case 6: return { 'background-color': '#5FC3E1', 'color': '#ffffff' };
      case 7: return { 'background-color': '#B80F61', 'color': '#ffffff' };
      case 8: return { 'background-color': '#080C35', 'color': '#ffffff' };
      case 9: return { 'background-color': '#004A99', 'color': '#ffffff' };
      default: return { 'background-color': '#ffffff', 'color': '#080C35' };
    }
  }
    get iconEstado() {
    return this.aportacion?.estado?.id === 3 ? 'check_circle' : 'warning_amber';
  }
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackbarSrv: SnackbarService,
    private dialogRef: MatDialogRef<ContributionsDisDialogComponent>,
    private estadoAportacionesService: AportacionDIEstadoControllerService,
    private aportacionesDiService: AportacionDiAdheridoControllerService,
    private adheridoControllerService: AdheridoControllerService,
    private adheridosService: AdheridoControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService | any,
    @Inject(MAT_DIALOG_DATA) public aportacion: AportacionDIAdheridoDTO | any,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private validateSrv: ValidateService,
    private parametrosControllerService: ParametrosControllerService
  ) {
    this.inicializarForm();
    this.inicializarFormUipath();
    this.defaultOperacionesGestionParameters = {codigoLer: [this.modelForm.get('codigoLer')?.value?.id ?? null], poseedores: true};
  }

  ngOnInit() {
    this.spinnerSrv.loadingShow();
    let peticionInicial = this.buscarInicialAdherido();
    peticionInicial.subscribe({
      next: () => {
        this.cargaInicial();
        this.spinnerSrv.loadingHide();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });

this.parametrosControllerService.findAll7().subscribe({
        next: (parametros: any) => {
          const parametroCantidadMaxima = parametros.find((p: any) => p.id === 3);
          if (parametroCantidadMaxima?.valor) {
            this.cantidadMaxima = parseInt(parametroCantidadMaxima.valor);
          }

          const parametroCantidadMinima = parametros.find((p: any) => p.id === 2);
          if (parametroCantidadMinima?.valor) {
            this.cantidadMinima = parseInt(parametroCantidadMinima.valor);
          }
        }
    });

  }

  inicializarForm() {
    if(this.aportacion.fechaAportacion){
      this.aportacion.fechaAportacion = this.aportacion.fechaAportacion ?? new Date().toISOString();
    }
    if(this.aportacion.gestorResiduo == null && this.aportacion.nimaGestor != null && this.aportacion.nimaGestor != ''){
      this.aportacion.gestorResiduo = {
        nima: this.aportacion.nimaGestor
      }
    }
    this.modelForm = this.formBuilder.group({
      id: [{ value: this.aportacion?.id }],
      documentoIdentificacion: [
        { value: this.aportacion?.documentoIdentificacion, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      fechaAceptacion: [
        { value: this.aportacion?.fechaAceptacion, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fechaAportacion: [
        { value: this.aportacion?.fechaAportacion, disabled: true },
      ],
      estado: [{ value: this.aportacion?.estado, disabled: false }],

      adherido: [
        { value: this.aportacion?.adherido, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      nimaGestor: [
        { value: this.aportacion?.gestorResiduo, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],

      documento: [{ value: this.aportacion?.documento, disabled: false }],
      
      codigoLer: [
        { value: this.aportacion?.codigoLer, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      gestorResiduo: [
        { value: this.aportacion?.gestorResiduo, disabled: false },
      ],
      operacionGestion: [
        { value: this.aportacion?.operacionGestion, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],

      cantidadGestionada: [
        { value: this.aportacion?.cantidadGestionada, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.min(0.000000001)]) },
      ],
        subirDocumentoOnEdit: [
        { value: false, disabled: false },
        //  { validators: Validators.compose([Validators.required]) },
        ],
      confirmacionDatos: [
        { value: null, disabled: false },
        //{ validators: Validators.compose([Validators.required]) }
      ],
    });

    //this.valueChangeCodigoLer();
  }

  assignEvents(){
    
    const sub = this.modelForm.controls[
      'fechaAceptacion'
    ].valueChanges.subscribe((val) => {
      this.buscarNimaGestor(val, this.modelForm.value?.adherido);
      this.buscaCodigoLer(
        val,
        this.modelForm.value?.adherido,
        this.modelForm.value?.nimaGestor
      );
      //this.gestionArray = [];
    });
    const sub2 = this.modelForm.controls['adherido'].valueChanges.subscribe(
      (val) => {
        //Este if es temporal, dado que se tiene que ajustar el caso de uso de edicion para gestores de envalora en estado revisada.
        if(!this.gestorEnvaloraCanEditAportacion()){
        this.buscarNimaGestor(this.modelForm.value?.fechaAceptacion, val);
        this.buscaCodigoLer(
          this.modelForm.value?.fechaAceptacion,
          val,
          this.modelForm.value?.nimaGestor
        );
      }
    }
    );
    const sub3 = this.modelForm.controls['nimaGestor'].valueChanges.subscribe(
      (val) => {
        this.buscaCodigoLer(
          this.modelForm.value?.fechaAceptacion,
          this.modelForm.value?.adherido,
          val
        );
      }
    );
    this.subscriptions.push(sub);
    this.subscriptions.push(sub2);
    this.subscriptions.push(sub3);
  }

  cargaInicial() {
    this.roleEntities = (this.authService.user as any).roleEntities;
    if (this.aportacion?.id) {
      this.titulo = 'Editar aportación de DI/FS';
      this.edicion = true;
    } else {
      this.titulo = 'Alta de aportación de DI/FS';
      this.edicion = false;
    }



    this.cargaCombos = true;
    // if (!this.canSaveAll() && !this.gestorEnvaloraCanEditAportacion()) {
    //   this.modelForm.disable();
    //   this.cargaCombos = false;
    // }

        if (!this.canSaveAll()) {
          if(!this.canUpdateEstadoPdteRevision() && !this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
            this.modelForm.disable();
            this.cargaCombos = false;
          }else{
            if(this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
              this.modelForm.get('confirmacionDatos')?.setValidators(Validators.compose([Validators.required]));
              this.modelForm.get('confirmacionDatos')?.updateValueAndValidity();
            }else{
              this.modelForm.get('confirmacionDatos')?.disable();
            }
            
          }
        }

    if (this.gestorEnvaloraCanEditAportacion()) {
      this.modelForm.get('subirDocumentoOnEdit')?.setValidators(Validators.compose([Validators.required]));
      this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
    } else {
      this.modelForm.get('subirDocumentoOnEdit')?.clearValidators();
      this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
    }

    this.estadoAportacionesService
      .findAll14()
      .subscribe((estados) => (this.estadoArray = estados));

    if(this.cargaCombos ){
      if(!this.gestorEnvaloraCanEditAportacion()){

        this.getAdheridos();
      }
      if(this.gestorEnvaloraCanEditAportacion()){
        this.adheridoArray.push(this.aportacion?.adherido)
        this.setItemSelected('adherido', 'id', this.adheridoArray, false);

      }
      this.buscarNimaGestor(
        this.modelForm.value?.fechaAceptacion,
        this.modelForm.value?.adherido
      );
      this.buscaCodigoLer(
        this.modelForm.value?.fechaAceptacion,
        this.modelForm.value?.adherido,
        this.modelForm.value?.nimaGestor,
        false
      );
    }else{
      //La aportacion no se va a editar, por lo que no tiene sentido cargar los combos con todos los datos disponibles
      //Se cargan los datos con lo que tiene el detalle o lo detectado por UiPath
      if(this.aportacion?.adherido){
        this.adheridoArray.push(this.aportacion?.adherido);
        this.setItemSelected('adherido', 'id', this.adheridoArray, false);
      }
      
      const gestor = this.aportacion?.gestorResiduo;
      if(gestor){
        this.nimaGestorArray.push(gestor);
        this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, false);
      }

      const ler = this.aportacion?.codigoLer;
      if(ler){
        this.codigoLerArray.push(ler);
        this.setItemSelected('codigoLer', 'id', this.codigoLerArray, false);
      }

      const gestion = this.aportacion?.operacionGestion;
      if(gestion){
        this.gestionArray.push(gestion);
        this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);
      }
    }
    
    this.updateDisableField('documentoIdentificacion');
    this.updateDisableField('fechaAceptacion');
    this.updateDisableField('cantidadGestionada');

    if(this.cargaCombos){
      this.assignEvents();
      this.valueChangeCodigoLer();
    }

  }

  buscarInicialAdherido(): Observable<any> {
    return this.adheridoControllerService
      .obtenerAdheridoPorId(this.aportacion?.adherido?.id)
      .pipe(tap((res) => (this.aportacion.adherido = res)));
  }

  updateDisableField(field: any): void {
    if (this.aportacion.estado) {
      if (!this.canAccessEditEstado() && (!this.gestorEnvaloraCanEditAportacion)) {
        this.modelForm.get(field)?.disable();
      }
    }
  }

  buscarNimaGestor(fechaAceptacion: any, adherido: any) {
    if (!fechaAceptacion || !adherido?.id) {
      this.nimaGestorArray = this.aportacion?.gestorResiduo ? [this.aportacion.gestorResiduo] : [];
      this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, false);
      return;
    }
    const filtroNimaGestor: SolicitudGestoresDTO = {
      fechaAceptacion: fechaAceptacion,
      adherido: {
        id: adherido.id,
      },
    };
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService.gestoresDelAdherido(filtroNimaGestor).subscribe({
      next: (res) => {
        this.nimaGestorArray = res;
        if (this.aportacion?.gestorResiduo && !this.nimaGestorArray.some((g: any) => g.nima == this.aportacion.gestorResiduo.nima)) {
          this.nimaGestorArray.push(this.aportacion.gestorResiduo);
        }
        this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, false);

        this.spinnerSrv.loadingHide();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  buscarAherido(fechaAceptacion: any, nimaGestor: any) {
    const filtroAdherido: SolicitudAdheridoPrevisionDTO = {
      fechaAceptacion: fechaAceptacion,
      gestor: nimaGestor,
    };
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService
      .getAdheridosEnPrevision(filtroAdherido)
      .subscribe({
        next: (res) => {
          this.adheridoArray = res;
          this.setItemSelected('adherido', 'id', this.adheridoArray, false);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  getAdheridos() {
    let filter: BusquedaAdheridoDTO = {
      estado: [6],
      declaracionFacturada: true,
    };
    if (this.authService.user?.roleEntities?.length > 0) {
      const adheridosIds = this.authService.user?.roleEntities
        .filter((adheridoRol: any) => adheridoRol.type === 'ADHERIDO')
        .flatMap((adheridoRol: any) => {
          if(adheridoRol.entity == null || adheridoRol.entity == undefined){
            return [];
          }else if (Array.isArray(adheridoRol.entity)) {
            return adheridoRol.entity;
          } else {
            return [adheridoRol.entity];
          }
        });
      const filter: BusquedaAdheridoDTO = {
        id: adheridosIds,
        estado: [6],
        declaracionFacturada: true,
      };

      this.spinnerSrv.loadingShow();
      this.adheridoControllerService
        .listarAdheridos({ page: 0, size: 100 }, filter)
        .subscribe({
          next: (response: any) => {
            this.adheridoArray = response?.datos;
            this.setItemSelected('adherido', 'id', this.adheridoArray, false);
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  buscaCodigoLer(fechaAceptacion: any, adherido: any, gestor: any, emitEvent: boolean = true) {
    if (fechaAceptacion && adherido && gestor) {
      this.spinnerSrv.loadingShow();
      const anoAceptacion = new Date(fechaAceptacion).getFullYear();
      this.adheridosService
        .codigoLer(adherido.id, gestor.nima, anoAceptacion)
        .subscribe({
          next: (res) => {
            this.codigoLerArray = res;
            this.setItemSelected('codigoLer', 'id', this.codigoLerArray, emitEvent);
            
            // Si el campo está vacío, intentamos cargar el valor detectado por UiPath o el único disponible
            if (!this.modelForm.get('codigoLer')?.value && this.codigoLerArray.length > 0) {
              if (this.aportacion?.codigoLer) {
                const match = this.codigoLerArray.find(c => c.id === this.aportacion.codigoLer.id);
                if (match) {
                  this.modelForm.get('codigoLer')?.patchValue(match, { emitEvent });
                }
              } else if (this.codigoLerArray.length === 1) {
                this.modelForm.get('codigoLer')?.patchValue(this.codigoLerArray[0], { emitEvent });
              }
            }

            // Independientemente de si se emite el evento o no, mantenemos actualizado
            // el filtro de la operación de gestión con el codigoLer real seleccionado,
            // para evitar que se envíe codigoLer null al backend.
            const codigoLerId = this.modelForm.get('codigoLer')?.value?.id ?? null;
            this.defaultOperacionesGestionParameters = { codigoLer: [codigoLerId], poseedores: true };

            this.spinnerSrv.loadingHide();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    } else {
      // En la carga inicial sin fecha no hay consulta; se muestra el LER guardado en la aportación
      this.codigoLerArray = !emitEvent && this.aportacion?.codigoLer ? [this.aportacion.codigoLer] : [];
      this.gestionArray = [];
    }
  }

  valueChangeCodigoLer() {
    this.modelForm.get('codigoLer')?.valueChanges.subscribe((value: any) => {
      if (value) {
        const operacionPrevia = this.modelForm.controls['operacionGestion'].value;
        this.modelForm.controls['operacionGestion'].reset();
        this.defaultOperacionesGestionParameters = {codigoLer: [value?.id ?? null], poseedores: true};
        this.updateList = !this.updateList;
        this.buscarOperacionesGestion(operacionPrevia);
      } else {
        this.defaultOperacionesGestionParameters = {codigoLer: [null], poseedores: true};
        this.modelForm.controls['operacionGestion'].reset();
        this.gestionArray = [];
      }
    });
  }

  buscarOperacionesGestion(operacionPrevia?: any) {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.operacionGestionControllerService
      .findByCodigoOperacion(backendFilter, { page: page, size: size })
      .subscribe({
        next: (res) => {
          if (res) {
            this.gestionArray = res?.datos ?? [];
            this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);

            // Prioridad: operación previa válida para el nuevo LER, valor de la aportación, valor de UiPath, única opción
            if (!this.modelForm.get('operacionGestion')?.value && this.gestionArray.length > 0) {
              const candidatas = [operacionPrevia, this.aportacion?.operacionGestion, this.aportacion?.operacionGestionReferenceUipath];
              let match = null;
              for (const c of candidatas) {
                match = c ? this.gestionArray.find(g => g.id === c.id) : null;
                if (match) break;
              }
              if (!match && this.gestionArray.length === 1) {
                match = this.gestionArray[0];
              }
              if (match) {
                this.modelForm.get('operacionGestion')?.patchValue(match);
              }
            }

            this.updateDisableField('operacionGestion');
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    const backendFilter: CodigoOperacionFilterDTO = {
      codigoLer: [this.modelForm.get('codigoLer')?.value?.id],
      sddrcc: true
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }

  private setItemSelected(
    controlName: string,
    propertyName: string,
    items: any[],
    emitEvent:boolean
  ) {
    let selectedItem = null;
    if (this.modelForm.value[controlName]) {
      if (
        typeof this.modelForm.value[controlName] == 'object' &&
        this.modelForm.value[controlName][propertyName]
      ) {
        selectedItem = items.find(
          (item) =>
            this.modelForm.value[controlName][propertyName] ==
            item[propertyName]
        );
      } else {
        selectedItem = items.find(
          (item) => this.modelForm.value[controlName] == item[propertyName]
        );
      }
    }
    this.modelForm.controls[controlName].patchValue(selectedItem, {
      emitEvent: emitEvent,
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  buttonSaveData(estadoId: any) {
    this.modelForm.markAllAsTouched();
    this.modelForm.updateValueAndValidity();

    if (this.aportacion?.documento == null) {
      if (this.documento == undefined || this.documento == null) {
        this.snackbarSrv.showSnackBar('Adjunte documento', 'error');
        return;
      }
    }

    if (this.modelForm.valid) {
      const todayDate = new Date();
      const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      if(fechaAceptacion > todayDate){
        this.snackbarSrv.showSnackBar(
          'La fecha de aceptación no puede ser posterior a la fecha actual.',
          'error'
        );
        return;
      }
      
      const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
      if(cantidadGest && (cantidadGest < this.cantidadMinima || cantidadGest > this.cantidadMaxima || cantidadGest == 0)){
        swal.fire({
          text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Guardar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.saveData(estadoId);
          }
        });
      }else{
        this.saveData(estadoId);
      }
    }
  }

  saveData(estadoId: any) {
    const formValue = this.modelForm.value;
    const aportacionPayload: AportacionDIAdheridoPayloadDTO = formValue;
    //aportacionPayload.gestorResiduo = formValue.nimaGestor;
    if(formValue.nimaGestor.id != null && formValue.nimaGestor.id != undefined){
      aportacionPayload.gestorResiduo = formValue.nimaGestor;
      aportacionPayload.nimaGestor = '';
    }else{
      aportacionPayload.nimaGestor = formValue.nimaGestor.nima;
    }
    if (aportacionPayload.estado !== undefined && estadoId !== null) {
      aportacionPayload.estado!.id = estadoId;
    }
      if(formValue.subirDocumentoOnEdit === true){
      aportacionPayload.nuevoDocumento = true;
    }
    aportacionPayload.fechaAceptacion = moment(aportacionPayload.fechaAceptacion).format('YYYY-MM-DD');
    let request, successMsg: string, errorMsg: string;
    if (this.aportacion?.id) {
      request = this.aportacionesDiService.editByIdAportacionDIAdherido(
        this.aportacion.id,
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha editado correctamente';
      errorMsg = 'Ha ocurrido un error al editar la aportación DI/FS';
    } else {
      if (!this.documento) {
        this.snackbarSrv.showSnackBar(
          'Debe seleccionar un documento',
          'error'
        );
        return;
      }

      request = this.aportacionesDiService.createAportacionDIAdherido(
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha creado correctamente';
      errorMsg = 'Ha ocurrido un error al crear la nueva aportación DI/FS';
    }

    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackbarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        this.aportacion.estado.id = 1;
        this.spinnerSrv.loadingHide();
      },
    });
  }

  showClearButton(formName: string): boolean {
    return this.modelForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.modelForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo) {
      if (archivo.size === 0) {
        this.snackbarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackbarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.documento = archivo;
      }
    }
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(documento.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  canAccessEditEstado(): boolean {
    return this.aportacion?.estado?.id === 1;
  }

  canAccessEditByRol(): boolean {
    return this.authService.can('adheridos-di-detalle', 'access-update');
  }

  canSaveAll(): boolean {
    if (this.canAccessEditByRol() && this.canAccessEditEstado()) {
      if (
        this.edicion &&
        this.aportacion.creadoPor == this.authService.getCurrentUserMail()
      ) {
        return true;
      } else if (!this.edicion) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  openModalAyuda(){
    const dialogRef = this.dialog.open(
        ContributionsDisImageDialogComponent,
        {
          width: '98%',
          maxWidth: '98%',
          maxHeight: '95vh',
          disableClose: true,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
      });
  }

  canAccessAcceptAportacion(){
    const resultAccept = this.authService.can('adheridos-di', 'update-accept');
    const estado2 = this.aportacion.estado && this.aportacion.estado.id === 2;
    return resultAccept && estado2;
  }

  canAccessCancelAportacion(){
    const resultCancel = this.authService.can('adheridos-di', 'update-cancel');
    const estado2 = this.aportacion.estado && (this.aportacion.estado.id === 3 || this.aportacion.estado.id === 7 || this.aportacion.estado.id === 8);
    return resultCancel && estado2;
  }

  acceptAportacion(){
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService
      .actualizarEstado(this.aportacion.id, 3)
      .subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar(
            'Se ha aceptado la aportación correctamente',
            'success'
          );
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          console.log(err);
        },
      });
  }

  openModalMotivoCancelAportacion(){
    const dialogRef = this.dialog.open(
      ContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: this.aportacion,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }

  vistaPreviaAportacion(element:any){
    const dialogRef = this.dialog.open(ContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }

    esGestorEnvalora(){
    return (this.canViewRol('AD-ENV-GEST') || this.canViewRol('AD-ENV-CONS'));
  }

    canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  gestorEnvaloraCanEditAportacion(){
    return (this.esGestorEnvalora() && this.puedeEditarAportacionEstadoCorrecionEnvalora() && this.aportacion?.estado?.id === 10)
  }

  inicializarFormUipath() {
    //if (this.aportacion?.id) {
      //this.aportacion.fechaAceptacionUipath = this.aportacion.fechaAceptacionUipath ?? new Date().toISOString();
      let gestorUipath;
      if(this.aportacion?.gestorResiduoReferenceUipath){
        gestorUipath =  `${this.aportacion?.gestorResiduoReferenceUipath.nima || ''}${this.aportacion?.gestorResiduoReferenceUipath.razonSocial ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.razonSocial : ''}${this.aportacion?.gestorResiduoReferenceUipath.centro ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.centro : ''}`;
      }else if(this.aportacion?.nimaGestorUipath){
        gestorUipath = this.aportacion?.nimaGestorUipath;
      }
      let adheridoUiPath;
      if(this.aportacion?.adheridoReferenceUipath){
        adheridoUiPath =  `${this.aportacion?.adheridoReferenceUipath.codigoDocumento} - ${this.aportacion?.adheridoReferenceUipath.razonSocial}`;
      }else if(this.aportacion?.codigoDocumentoAdheridoUipath){
        adheridoUiPath = this.aportacion?.codigoDocumentoAdheridoUipath;
      }
      let codLerUipath;
      if(this.aportacion?.codigoLerReferenceUipath){
        codLerUipath =  `${this.aportacion?.codigoLerReferenceUipath.tipoCodigo} - ${this.aportacion?.codigoLerReferenceUipath.descripcion}`;
      }else if(this.aportacion?.codigoLerUipath || this.aportacion?.descripcionCodigoLerUipath){
        codLerUipath = `${this.aportacion?.codigoLerUipath} - ${this.aportacion?.descripcionCodigoLerUipath}`;
      }
      let operUipath;
      if(this.aportacion?.operacionGestionReferenceUipath){
        operUipath =  `${this.aportacion?.operacionGestionReferenceUipath.codigo} - ${this.aportacion?.operacionGestionReferenceUipath.descripcion}`;
      }else if(this.aportacion?.codigoOperacionUipath || this.aportacion?.descripcionOperacionUipath){
        operUipath = `${this.aportacion?.codigoOperacionUipath} - ${this.aportacion?.descripcionOperacionUipath}`;
      }
      this.uipathForm = this.formBuilder.group({
        id: [{ value: this.aportacion?.id }],
        documentoIdentificacionUipath: [ { value: this.aportacion?.documentoIdentificacionUipath, disabled: true }],
        fechaAceptacionUipath: [{ value: this.aportacion?.fechaAceptacionUipath, disabled: true }],
        adheridoUipath: [{ value: adheridoUiPath, disabled: true }],
        nimaGestorUipath: [{ value: gestorUipath, disabled: true }],
        codigoLerUipath: [ { value: codLerUipath, disabled: true }],
        operacionGestionUipath: [  { value: operUipath,  disabled: true }],
        cantidadGestionadaUipath: [{ value: this.aportacion?.cantidadGestionadaUipath, disabled: true }],
      });

      this.uipathForm.disable();
    //}
  }

        canUpdateEstadoPdteRevision(){
    //const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    //return estado7;
    return this.canAccessRevisarAportacion();
  }

    canAccessRevisarAportacion(){
    const resultRevisar =  this.authService.can('adheridos-di', 'update-revisar');
    const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    return (resultRevisar && estado7);
  }

  buttonRevisarAportacion() {
    this.modelForm.markAllAsTouched();
    this.modelForm.updateValueAndValidity();

    if (this.modelForm.valid) {
      const todayDate = new Date();
      const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      if (fechaAceptacion > todayDate) {
        this.snackbarSrv.showSnackBar(
          'La fecha de aceptación no puede ser posterior a la fecha actual.',
          'error'
        );
        return;
      }
    }

    if (this.modelForm.valid) {
      const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
      if (cantidadGest && cantidadGest < 100) {
        swal.fire({
          text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Guardar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.revisarAportacion();
          }
        });
      } else {
        this.revisarAportacion();
      }
    } else {
      this.snackbarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
    }
  }


  revisarAportacion() {
    const aportacionPayload: any = this.getAportacionPayload(null);
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService.revisarAportacion(this.aportacion.id, aportacionPayload).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackbarSrv.showSnackBar('La aportación DI se ha revisado correctamente', 'success');
      },
      error: () => {
        this.snackbarSrv.showSnackBar('Ha ocurrido un error al revisar la aportación DI', 'error');
        this.spinnerSrv.loadingHide();
      },
    });
  }

  getAportacionPayload(estadoId: any) {
    const formValue = this.modelForm.value;
    const aportacionPayload: any = formValue;
    //aportacionPayload.gestorResiduo = formValue.nimaGestor;
    if (formValue.nimaGestor.id != null && formValue.nimaGestor.id != undefined) {
      aportacionPayload.gestorResiduo = formValue.nimaGestor;
      aportacionPayload.nimaGestor = '';
    } else {
      aportacionPayload.nimaGestor = formValue.nimaGestor.nima;
    }
    if (aportacionPayload.estado !== undefined && estadoId !== null) {
      aportacionPayload.estado!.id = estadoId;
    }
    aportacionPayload.fechaAceptacion = moment(aportacionPayload.fechaAceptacion).format('YYYY-MM-DD');
    if (!aportacionPayload.documentoIdentificacion) {
      aportacionPayload.documentoIdentificacion = this.modelForm?.get("documentoIdentificacion")?.value;
    }
    if (!aportacionPayload.esAportacionSDDRCA) {
      aportacionPayload.esAportacionSDDRCA = false;
    }

    if (formValue.subirDocumentoOnEdit === true) {
      aportacionPayload.nuevoDocumento = true;
    }
    return aportacionPayload;
  }

  canAccessDeleteAportacion() {
    const resultDelete = this.authService.can('adheridos-di-detalle', 'delete');
    const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    return resultDelete && estado7;
  }

    openConfirmacionEliminar(): void {
      swal.fire({
        text: `¿Está seguro de eliminar este registro?
                El documento se eliminará de ENVANET y no podrá volver a consultarlo.`,
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.eliminarAportacion();
        }
      });
    }

  eliminarAportacion() {
    if (this.aportacion?.id) {
      this.spinnerSrv.loadingShow();
      this.aportacionesDiService
        .deleteAportacionById(this.aportacion?.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar(
              `La aportación DI se ha eliminado correctamente.`,
              'success'
            );
            this.dialogRef.close(true);
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar(
              `Ha ocurrido un error al eliminar la aportación DI: ${err.message}`,
              'error'
            );
          },
        });
    }
  }

  puedeEditarAportacionEstadoCorrecionEnvalora(){
    return this.canViewRol('SDDR-CC-APORT-EDIC-TOTAL-ENV-GEST');
  }
    
  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'operacionGestion': {
        return this.modelForm.get('operacionGestion') as FormControl;
      }
      default: {
        return this.modelForm.get('') as FormControl;
      }
    }
  }

  getOperacionesGestionDescription(obj: any) {
    if (obj) {
      return obj.codigo + ' ' + obj.descripcion;
    }
    return '';
  }

  getOperacionesGestionObjectQuery(searchterm: string) {
    return {
      codigoOrDescripcion: `${searchterm}`,
    };
  }

  isEdicionMode(): boolean {
    return !!(this.aportacion && this.aportacion?.id > 0 && !this.aportacion?.externa);
  }

  fieldDiffers(fieldName: string): boolean {
    if (!this.isEdicionMode() || !this.uipathForm) return false;
    switch (fieldName) {
      case 'documentoIdentificacion': {
        const left = this.modelForm.get('documentoIdentificacion')?.value;
        const right = this.uipathForm.get('documentoIdentificacionUipath')?.value;
        if (!left && !right) return false;
        return this.normalizeString(left) !== this.normalizeString(right);
      }
      case 'fechaAceptacion': {
        const left = this.modelForm.get('fechaAceptacion')?.value;
        const right = this.uipathForm.get('fechaAceptacionUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        return moment(left).format('YYYY-MM-DD') !== moment(right).format('YYYY-MM-DD');
      }
      case 'adherido': {
        const left = this.modelForm.get('adherido')?.value;
        const right = this.uipathForm.get('adheridoUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.codigoDocumento || ''} - ${left.razonSocial || ''}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'nimaGestor': {
        const left = this.modelForm.get('nimaGestor')?.value;
        const right = this.uipathForm.get('nimaGestorUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.nima || ''}${left.razonSocial ? ' - ' + left.razonSocial : ''}${left.centro ? ' - ' + left.centro : ''}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'codigoLer': {
        const left = this.modelForm.get('codigoLer')?.value;
        const right = this.uipathForm.get('codigoLerUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.tipoCodigo} - ${left.descripcion}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'operacionGestion': {
        const left = this.modelForm.get('operacionGestion')?.value;
        const right = this.uipathForm.get('operacionGestionUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.codigo} - ${left.descripcion}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'cantidadGestionada': {
        const left = this.modelForm.get('cantidadGestionada')?.value;
        const right = this.uipathForm.get('cantidadGestionadaUipath')?.value;
        const leftEmpty = left === null || left === undefined || left === '';
        const rightEmpty = right === null || right === undefined || right === '';
        if (leftEmpty && rightEmpty) return false;
        if (leftEmpty || rightEmpty) return true;
        return Number(left) !== Number(right);
      }
      default:
        return false;
    }
  }

  private normalizeString(val: any): string {
    if (val === null || val === undefined) return '';
    return val.toString().trim().toLowerCase();
  }
}
